import { Injectable, Signal } from '@angular/core';
import { IGlobalConfig } from '@partners/api';
import { ConfigFacade } from './config.facade';

@Injectable({
  providedIn: 'root'
})
export class GlobalConfig extends ConfigFacade {
  get configDictionary$$(): Signal<IGlobalConfig> {
    return this._shellStore.globalConfig$$;
  }

  constructor() {
    super();
  }
}
